function initialState() {
  return {
    hasFinanceData: null,
    financeData: null,

    // Raw payload of GET /accounts/:key/revenue/podcasts/:frequency, or null when the
    // report hasn't been fetched / isn't served by the backend yet.
    podcastRevenue: null,
    isPodcastRevenueAvailable: false,

    // Raw payload of GET /accounts/:key/revenue/podcasts — the same totals broken down
    // per podcast instead of per time bucket. Null when unfetched/unavailable.
    podcastRevenueByPodcast: null,

    invoiceSettings: {
      accountKey: "",
      referenceNumber: "",
      mount: "",
      cpmRate: "",
      brdEmail: "",
      accountName: "",
    },

    financePeriod: {
      from: "",
      to: "",
    },

    financeFrequency: "daily",
  }
}

let state = initialState()

export { initialState, state }
